import {
  FilterRequest,
  ContactTypeDoc,
  ContactTypeResponse,
  ContactTypesResponse,
  ContactTypeLightResponse,
} from '@/types/entities';
import { ApiService } from './api.service';
import { endpoints } from './endpoints';

/**
 * Service for handling contact type-related API calls
 */
export class ContactTypesApiService extends ApiService {
  // Get all contact types (reference data)
  getAll = async (): Promise<ContactTypeLightResponse> => this.get(endpoints.contactTypes.all);

  getFilteredContactTypes = async (filters: FilterRequest): Promise<ContactTypesResponse> =>
    this.post(endpoints.contactTypes.filtered, filters);

  deleteContactType = async (id: string): Promise<void> =>
    this.delete(endpoints.contactTypes.delete(id));

  getContactTypeById = async (id: string): Promise<ContactTypeResponse> =>
    this.get(endpoints.contactTypes.byId(id));

  createContactType = async (data: Partial<ContactTypeDoc>): Promise<ContactTypeDoc> =>
    this.post(endpoints.contactTypes.create, data);

  updateContactType = async (id: string, data: Partial<ContactTypeDoc>): Promise<ContactTypeDoc> =>
    this.patch(endpoints.contactTypes.update(id), data);
}

// Export a singleton instance
export const contactTypesApiService = new ContactTypesApiService();

// Named exports for convenience
export const {
  getAll: getContactTypes,
  getFilteredContactTypes,
  deleteContactType,
  getContactTypeById,
  createContactType,
  updateContactType,
} = contactTypesApiService;
